import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { Userpilot } from 'userpilot';
import { useLocation } from 'react-router';

import getEnv from '@/shared/configs/env';
import { userShouldBeIdentifiedForUserPilot } from '@/utils/commonUtils';
import type { User } from '@/utils/types/User';
import { useAnalyticsContext } from './AnalyticsContext';

export const UserIdentification = ({ user }: { user: User }) => {
  const { pathname } = useLocation();
  const { identify, isReady } = useAnalyticsContext();

  useEffect(() => {
    if (isReady) identify(user);

    if (userShouldBeIdentifiedForUserPilot(user.email)) {
      Userpilot.identify(user.id ?? '', {
        name: user.firstName ?? '',
        email: user.email ?? '',
        LLType: user.LLType,
        canEnrollProperties: user.canEnrollProperties,
        referralId: user.partner ?? '',
        env: getEnv().app_env,
      });
    }

    datadogRum.setUser({
      id: user.id ?? '',
      email: user.email ?? '',
      name: `${user.firstName} ${user.lastName}`,
      permissions: user.userPermissions,
      LLType: user.LLType,
      env: getEnv().app_env,
    });
  }, [identify, isReady, user]);

  useEffect(() => {
    Userpilot.reload();
  }, [pathname]);

  return null;
};
